
(function(){
  var ATTR="data-ss-clamp",FOLD="is-folded",MS=220,DEFAULT=10;
  function reduced(){try{return window.matchMedia("(prefers-reduced-motion: reduce)").matches}catch(e){return false}}
  // Animate between the two states by height, because the clamp itself cannot be
  // tweened: measure where we are, measure where the other state settles, then
  // run max-height between them with the clamp off, and put it back at the end.
  function setFolded(el,fold,animate){
    window.clearTimeout(el.__ssFoldT);
    if(!animate){
      el.style.transition="";el.style.maxHeight="";el.style.overflow="";
      el.classList.toggle(FOLD,fold);return;
    }
    var from=el.offsetHeight;
    el.style.maxHeight="";                 // measure the real other state, not a
    el.classList.toggle(FOLD,fold);        // frame of an animation still running
    var to=el.offsetHeight;
    el.classList.remove(FOLD);
    el.style.overflow="hidden";
    el.style.maxHeight=from+"px";
    void el.offsetHeight;                  // commit the start height before flipping it
    el.style.maxHeight=to+"px";
    // A timer, not transitionend: reduced motion and a backgrounded tab never
    // fire one, and the cleanup is what re-applies the clamp.
    el.__ssFoldT=window.setTimeout(function(){
      el.style.maxHeight="";el.style.overflow="";
      if(fold)el.classList.add(FOLD);
    },MS+40);
  }
  function clear(el){
    if(el.__ssClampBtn&&el.__ssClampBtn.parentNode)el.__ssClampBtn.parentNode.removeChild(el.__ssClampBtn);
    el.__ssClampBtn=null;
    setFolded(el,false,false);
    el.classList.remove("ss-clamp");
  }
  window.ssClampLines=function(el,opts){
    if(typeof el==="string")el=document.getElementById(el);
    if(!el)return null;
    opts=opts||{};
    var lines=parseInt(opts.lines,10);
    if(!(lines>0))lines=parseInt(el.getAttribute(ATTR),10);
    if(!(lines>0))lines=DEFAULT;
    clear(el);
    el.classList.add("ss-clamp");
    el.style.setProperty("--ss-clamp-lines",String(lines));
    el.classList.add(FOLD);
    // An element with no layout (a panel still hidden, a tab in the background)
    // reports zero and cannot be measured. Count the text instead: a toggle on a
    // brief that turns out to fit costs one harmless click, while none on a brief
    // that doesn't hides the half of it nobody can reach.
    var over=el.clientHeight
      ? el.scrollHeight>el.clientHeight+2
      : (String(el.textContent||"").split("\n").length>lines||String(el.textContent||"").length>lines*70);
    if(!over){clear(el);return null}
    var more=opts.more||"Show more",less=opts.less||"Show less";
    var btn=document.createElement("button");
    btn.type="button";
    btn.className="ss-clamp-more"+(opts.className?" "+opts.className:"");
    btn.textContent=more;
    btn.setAttribute("aria-expanded","false");
    btn.onclick=function(){
      // The wanted state, read from our own flag rather than from the class: mid
      // animation the class is off in both directions.
      var fold=el.__ssOpen===true;
      el.__ssOpen=!fold;
      setFolded(el,fold,!reduced());
      btn.textContent=fold?more:less;
      btn.setAttribute("aria-expanded",fold?"false":"true");
      if(opts.onToggle)opts.onToggle(fold);
    };
    el.__ssOpen=false;
    el.__ssClampBtn=btn;
    if(opts.mount)opts.mount(btn);
    else (opts.host||el.parentNode).appendChild(btn);
    return btn;
  };
  // Markup that opts in: applied once the page is up, re-checked when a resize
  // could have changed how the same text wraps.
  function all(){
    var list=document.querySelectorAll("["+ATTR+"]");
    for(var i=0;i<list.length;i++){
      // Leave an open one open — re-folding text someone chose to read is the one
      // thing a resize must not do.
      if(list[i].__ssOpen)continue;
      window.ssClampLines(list[i]);
    }
  }
  if(document.readyState==="loading")document.addEventListener("DOMContentLoaded",all);
  else all();
  var t=null;
  window.addEventListener("resize",function(){clearTimeout(t);t=setTimeout(all,150)});
})();
